// extracted by mini-css-extract-plugin
export default {"globalContent":"layout_globalContent__jsiVS","withBetaMsg":"layout_withBetaMsg__jPcq8"};